import React, { useEffect, useState } from "react"
import useAuth from "../../hooks/useAuth"
import useAxiosPrivate from "../../hooks/useAxiosPrivate"
import productShopifyIdDecoder from "../../utils/shopifyProductIdDecoder"
import MobileAccountSidebar from "../AccountSidebar/mobile"
import OrderHistoryCard from "./Card"

interface OrdersList {
  node: Order
}

const OrderHistory = () => {
  const { auth, setAuth } = useAuth()
  const [orders, setOrders] = useState<OrdersList[]>()
  const privateAxios = useAxiosPrivate()
  const [loading, setLoading] = useState(false)
  const getOrders = async () => {
    setLoading(true)
    await privateAxios
      .post("/.netlify/functions/orders")
      .then(result => {
        const orders = result?.data?.customer?.orders?.edges || []
        if (orders?.length) {
          setOrders(orders)
        }
        setLoading(false)
      })
      .catch(err => {
        console.error(err)
      })
  }
  useEffect(() => {
    if (!auth?.accessToken || !auth?.email) {
      privateAxios
        .get("/.netlify/functions/account")
        .then(result => {
          const {
            id,
            email,
            firstName,
            lastName,
            defaultAddress,
            phone,
            metafields,
          } = result.data?.customer

          // Properly format retrieved data
          const customerShopifyId = productShopifyIdDecoder(id)
          const birthday = metafields.edges.filter(
            (metafield: any) => metafield.key === "birthDate",
          )
          const birthdayStr =
            birthday.length > 0
              ? birthday[0].value.replace(/-/g, "/").toDateString().substr(4)
              : "---"

          // Update auth info
          setAuth?.({
            ...auth,
            id: customerShopifyId,
            email: email,
            firstName: firstName,
            lastName: lastName,
            defaultAddress: defaultAddress,
            phone: phone,
            birthday: birthdayStr,
          })
        })
        .catch(err => {
          console.error("error retrieving data", err.message)
          if (!err?.response) {
            console.error("No Server Response")
          } else if (err.response?.status === 400) {
            console.error("Bad Request")
          } else if (err.response?.status === 401) {
            console.error("Unauthorized")
          } else if (err.reponse?.status === 403) {
            console.error("Forbidden")
          } else if (err.response.status === 500) {
            console.error(
              `Internal server error occured. Message from server: ${err.message}`,
            )
          } else {
            console.error(
              `Unknown error occured. Message from server: ${err.message}`,
            )
          }
        })
    }
  }, [])
  useEffect(() => {
    getOrders()
  }, [auth])

  return (
    <div className="w-full">
      <MobileAccountSidebar />
      <div className="flex flex-col min-h-screen w-full lg:justify-center items-center  lg:mt-0">
        <div className="flex justify-between px-6 2xl:px-0 items-center w-full pb-1 border-b-4 border-black max-w-4xl">
          <div className="flex items-center">
            <p className="uppercase text-lg text-obsidian font-extrabold mb-0">
              Order History
            </p>
          </div>
        </div>
        <div className="flex flex-col px-6 2xl:px-0 items-center w-full lg:max-w-4xl">
          {loading ? (
            <div role="status" className="mt-6">
              <svg
                aria-hidden="true"
                className="w-24 h-24 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-white"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-2 w-full">
              {orders?.length ? (
                orders.map((order, idx) => (
                  <OrderHistoryCard key={idx} {...order.node} />
                ))
              ) : (
                <p>No Orders found</p>
              )}
            </div>
          )}
          {orders?.length ? (
            <button
              disabled
              className="text-11 mt-10 tracking-widest min-w-200px w-full bg-obsidian text-white p-2 font-bold font-expanded uppercase hover:bg-paloverde mb-4"
            >
              END OF TRANSACTION HISTORY
            </button>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default OrderHistory
